import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"icon-file\"><g stroke=\"currentColor\" fill=\"none\"><path d=\"M13.5 3.5v9.497c0 .83-.68 1.503-1.496 1.503H2.996A1.5 1.5 0 0 1 1.5 13.002V1.998C1.5 1.171 2.177.5 3.007.5h7.496l2.997 3zM10.5.5v3M13.5 3.5h-3M4.5 4.5h3M4.5 7.5h6M4.5 10.5h6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol